import React from 'react';
import sharkImage from '../assets/images/Shark.jpg';
import './Home.css';

function Home() {
  return (
    <div className="home-container">
      <h1>Welcome to the FantaSea Fishing Tournament!</h1>
      <p>Good luck to all our anglers. May the biggest shark win!</p>
      <img src={sharkImage} alt="A large shark" />
    </div>
  );
}

export default Home;